export const HISTORY_IMPORT_MAX_ROWS = 10_000
export const HISTORY_CSV_HEADER = 'Discogs ID,date'

export function isValidHistoryDate(value: string): boolean {
	if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false
	const date = new Date(`${value}T00:00:00.000Z`)
	return (
		!Number.isNaN(date.getTime()) &&
		date.toISOString().slice(0, 10) === value
	)
}
